import {request} from '../../utils/request'
import {getToken, setToken, removeToken, setTokenData, getTokenExpireTime, setTokenExpireTime, setLastOperationTime, getLastOperationTime} from '@/utils/auth'
import router, {resetRouter} from '../../router'

const state = {
  token: getToken(),
  tokenExpireTime: getTokenExpireTime(),
  lastOperationTime: getLastOperationTime(),
  name: '',
  uid: '',
  portrait: '',
  introduction: '',
  reset_password_number: null,
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_TOKEN_EXPIRE_TIME: (state, time) => {
    state.tokenExpireTime = time
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_LAST_OPERATION_TIME: (state, time) => {
    state.lastOperationTime = time
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_PORTRAIT: (state, portrait) => {
    state.portrait = portrait
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_UID: (state, uid) => {
    state.uid = uid
  },
  SET_RESET_PASSWORD_NUMBER: (state, resetNumber) => {
    state.reset_password_number = resetNumber
  }
}

const actions = {
  // user login
  login({commit}, userInfo) {
    const {username, password, captcha, captcha_key} = userInfo
    return new Promise((resolve, reject) => {
      request('auth/token', 'get', {
        account: username.trim(),
        password: password,
        captcha: captcha,
        captcha_key: captcha_key
      }).then(response => {

        let time = (new Date().getTime() / 1000) + response.data.expires_in * 60
        commit('SET_TOKEN_EXPIRE_TIME', time);
        commit('SET_TOKEN', response.data.access_token)
        setToken(response.data.access_token)
        setTokenExpireTime(time)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  //刷新登录token
  refreshToken({commit}) {
    return new Promise((resolve, reject) => {
      request('auth/token/refresh', 'put').then(response => {
        let time = (new Date().getTime() / 1000) + response.data.expires_in * 60
        commit('SET_TOKEN_EXPIRE_TIME', time);
        commit('SET_TOKEN', response.data.access_token)
        setToken(response.data.access_token)
        setTokenExpireTime(time)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  //保存上次操作的事件
  lastOperationTime({commit}) {
    let time = new Date().getTime() / 1000
    commit('SET_LAST_OPERATION_TIME', time)
    setLastOperationTime(time)
  },

  // get user info
  getInfo({commit, state}) {
    return new Promise((resolve, reject) => {
      request('auth/info').then(response => {
        const {data} = response
        if (!data) {
          reject('请登录')
        }
        const {id, name, roles, portrait, reset_password_number} = data
        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_PORTRAIT', portrait)
        commit('SET_UID', id)
        commit('SET_RESET_PASSWORD_NUMBER', reset_password_number)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({commit, state, dispatch}) {
    return new Promise((resolve, reject) => {
      request('auth/token', 'delete').then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({commit}) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  changeRoles({commit, dispatch}, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const {roles} = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, {root: true})

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, {root: true})

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
